module.exports = __webpack_public_path__ + "img/check-app.a2111a4e.svg";